<template>
    <div class="destination">
        <CountryHeader></CountryHeader>
        <ServiceSelector></ServiceSelector>
        <GeneralInfo></GeneralInfo>
    </div>
</template>
<script>
import CountryHeader from './CountryHeader';
import ServiceSelector from './ServiceSelector';
import GeneralInfo from './Generalinfo';

export default {
    metaInfo() {
        return {
            title: `Roaming ${this.$root.selectedCountry.name} - ${this.$root.serviceActive.title} - cele mai tari oferte și tarife | Vodafone`,
            meta: [
                {
                    mid: 'description',
                    name: 'description',
                    content: `Profită acum de cel mai bun internet când ești în ${this.$root.selectedCountry.name} - cele mai tari oferte la roaming cu ${this.$root.serviceActive.url} ca să fii mereu conectat oriunde te-ai afla în afara țării`,
                },
            ],
        };
    },
    name: 'Destination',
    components: {
        CountryHeader,
        ServiceSelector,
        GeneralInfo,
    },
    watch: {
        $route(newRoute, oldRoute) {
            if (newRoute.params.country !== oldRoute.params.country) {
                this.getCountryFromURL();
            }
            let oldCountryName = newRoute.params.country.toUpperCase();
            let newCountryName = oldRoute.params.country.toUpperCase();

            // only on country change

            if (oldCountryName !== newCountryName) {
                dataLayer.push({
                    event: 'microData',
                    event_name: 'page_view',
                    page_name: `Roaming ${oldCountryName} LP`,
                    page_type: 'landing_page',
                    page_platform: 'website',
                    page_charset: 'UTF-8',
                    page_country: 'RO',
                    page_domain: 'vodafone.ro',
                    page_locale: 'RO-ro',
                    page_section: 'roaming',
                    page_channel: 'vodafone.ro',
                    user_selected_journey: 'NO_FLOW',
                    client_upc: 'no',
                });
            }
        },
    },
    methods: {
        getCountryFromURL: function () {
            var urlCountry = this.$root.countries.find((country) => country.nameClean === this.$route.params.country);
            this.$root.selectedCountry = urlCountry;
        },
    },
    mounted() {
        this.getCountryFromURL();
        dataLayer.push({
            event: 'microData',
            event_name: 'page_view',
            page_name: `Roaming ${this.$root.selectedCountry.name} LP`,
            page_type: 'landing_page',
            page_platform: 'website',
            page_charset: 'UTF-8',
            page_country: 'RO',
            page_domain: 'vodafone.ro',
            page_locale: 'RO-ro',
            page_section: 'roaming',
            page_channel: 'vodafone.ro',
            user_selected_journey: 'NO_FLOW',
            client_upc: 'no',
        });
    },
};
</script>
